import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "flex flex-col gap-2"
};
const _hoisted_2 = ["data-testid"];
const _hoisted_3 = { class: "font-medium" };
import { useI18n } from "vue-i18n";
import { RouterLink } from "vue-router";
import { Alert } from "@eudonet/opal";
import { DONATION_MODULE_SETTINGS_ROUTE_NAME } from "../composables/donationModuleSettingsTabs";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DonorReceiptInformationNotice',
    props: {
        gaps: {},
        unavailable: { type: Boolean },
        contactId: { default: undefined },
        organizationId: { default: undefined },
        headingKey: { default: "finance.donations.create.receiptInformation.title" },
        onRetry: { type: Function, default: undefined }
    },
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        function scopeLabel(scope) {
            return t(`finance.donations.create.receiptInformation.scope.${scope}`);
        }
        function fieldLabel(field) {
            return t(`finance.donations.create.receiptInformation.fields.${field}`);
        }
        /** The fiche to open to fix this gap; null when there is nowhere useful to send the user. */
        function routeFor(scope) {
            switch (scope) {
                case "organization":
                    return props.organizationId
                        ? { name: "Organisation", params: { id: props.organizationId } }
                        : null;
                case "beneficiary":
                    return { name: DONATION_MODULE_SETTINGS_ROUTE_NAME, query: { tab: "identity" } };
                default:
                    return props.contactId ? { name: "ContactDetail", params: { id: props.contactId } } : null;
            }
        }
        return (_ctx, _cache) => {
            return (__props.unavailable || __props.gaps.length > 0)
                ? (_openBlock(), _createBlock(_unref(Alert), {
                    key: 0,
                    layout: "stacked",
                    color: "warning",
                    "data-testid": __props.unavailable ? 'donor-receipt-information-unavailable' : 'donor-receipt-information-gaps',
                    heading: __props.unavailable
                        ? _ctx.$t('finance.donations.create.receiptInformation.unavailable')
                        : _ctx.$t(__props.headingKey)
                }, {
                    body: _withCtx(() => [
                        (__props.unavailable && __props.onRetry)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "underline",
                                "data-testid": "donor-receipt-information-retry",
                                onClick: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => (__props.onRetry && __props.onRetry(...args)))
                            }, _toDisplayString(_ctx.$t("finance.donations.create.receiptInformation.retry")), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                        (!__props.unavailable)
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.gaps, (gap) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        key: gap.scope,
                                        "data-testid": `donor-receipt-gap-${gap.scope}`
                                    }, [
                                        _createElementVNode("span", _hoisted_3, _toDisplayString(scopeLabel(gap.scope)), 1 /* TEXT */),
                                        _createElementVNode("span", null, " : " + _toDisplayString(gap.fields.map(fieldLabel).join(", ")), 1 /* TEXT */),
                                        (routeFor(gap.scope))
                                            ? (_openBlock(), _createBlock(_unref(RouterLink), {
                                                key: 0,
                                                to: routeFor(gap.scope),
                                                class: "ml-2 underline",
                                                target: "_blank",
                                                rel: "noopener",
                                                "data-testid": `donor-receipt-gap-link-${gap.scope}`
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t("finance.donations.create.receiptInformation.completeLink")), 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["to", "data-testid"]))
                                            : _createCommentVNode("v-if", true)
                                    ], 8 /* PROPS */, _hoisted_2));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["data-testid", "heading"]))
                : _createCommentVNode("v-if", true);
        };
    }
});
